import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from 'app/core/services/user.service';
import { User } from 'app/core/types/user.types';

export const BACKUP_PAGE_ENABLED = false;

export function canSeeBackup(
    user: User | undefined,
    enabled: boolean = BACKUP_PAGE_ENABLED
): boolean {
    return enabled && !!(user?.backupAccess || user?.systemAccess);
}

export const backupGuard: CanActivateFn = () =>
    canSeeBackup(inject(UserService).getUser()) ||
    inject(Router).createUrlTree(['/home']);
